import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { path } from './router';
import { pascalToCamelCase, pascalToKebabCase } from '../../minions/string';

export default function AppRedirectToModule(props) {
  const { userModule } = props;
  const navigate = useNavigate();
  const global = useSelector((state) => state.global);

  const redirect = useCallback(() => {
    switch (userModule?.name) {
      case 'SecureFiles':
        window.location = `${global?.urlData?.rootProject}${pascalToKebabCase(
          userModule?.name
        )}/${userModule[userModule?.name]?.slug}/`;
        break;

      // NEW
      case 'ChemicalTrading':
      case 'CommunicationPipeline':
      case 'LegalCompliance':
      case 'Intelligence':
      case 'UserManagement':
        navigate(
          path({
            name: `user_module_${pascalToCamelCase(userModule?.name)}_home`,
            params: {
              moduleBridgeHex: userModule?.hex,
            },
          })
        );
        break;
      case 'GlobalLegalCompliance':
        navigate(
          path({
            name: `user_module_${pascalToCamelCase(
              userModule?.name
            )}_evaluation`,
            params: {
              moduleBridgeHex: userModule?.hex,
              page: 1,
              filtersHex: 0,
            },
          })
        );
        break;
      case 'CorrectiveActions':
        navigate(
          path({
            name: `user_module_${pascalToCamelCase(
              userModule?.name
            )}_task_list`,
            params: {
              moduleBridgeHex: userModule?.hex,
              page: 1,
              filtersHex: 0,
            },
          })
        );
        break;
      case 'LawFinder':
        navigate(
          path({
            name: `user_module_${pascalToCamelCase(userModule?.name)}_home`,
            params: {
              moduleBridgeHex: userModule?.hex,
              page: 1,
              filters: 0,
            },
          })
        );
        break;
      case 'NewsletterManager':
        navigate(
          path({
            name: `user_module_${pascalToCamelCase(userModule?.name)}_home`,
            params: {
              moduleBridgeHex: userModule?.hex,
              page: 1,
            },
          })
        );
        break;
      case 'SaicaReports':
        navigate(
          path({
            name: 'user_module_saicaReport_home',
            params: {
              moduleBridgeHex: userModule?.hex,
              level: 4,
            },
          })
        );
        break;
      case 'InecoRiskManager':
        navigate(
          path({
            name: 'user_module_inecoRiskManager_risk_list',
            params: {
              moduleBridgeHex: userModule?.hex,
              page: 1,
              filtersHex: 0,
            },
          })
        );
        break;
      case 'ResourceManager':
        navigate(
          path({
            name: 'user_module_resourceManager_resource_home',
            params: {
              moduleBridgeHex: userModule?.hex,
              page: 1,
              filtersHex: 0,
            },
          })
        );
        break;
      case 'DocumentManager':
        navigate(
          path({
            name: 'user_module_documentManager_cover_redirect',
            params: {
              moduleBridgeHex: userModule?.hex,
            },
          })
        );
        break;
      case 'TotalEnergiesRisk':
        navigate(
          path({
            name: 'user_module_totalEnergiesRisk_risk_list',
            params: {
              moduleBridgeHex: userModule?.hex,
              page: 1,
              filtersHex: 0,
            },
          })
        );
        break;
      case 'EnvironmentalAspectsAssessment':
        navigate(
          path({
            name: 'user_module_environmentalAspectsAssessment_assessment_current',
            params: {
              moduleBridgeHex: userModule?.hex,
              plantHex: 0,
            },
          })
        );
        break;
      case 'AdvancedSearch':
        navigate(
          path({
            name: 'user_module_advancedSearch_home',
            params: {
              moduleBridgeHex: userModule?.hex,
            },
          })
        );
        break;
      case 'Survey':
        navigate(
          path({
            name: 'user_module_survey_home',
            params: {
              moduleBridgeHex: userModule?.hex,
            },
          })
        );
        break;
      case 'DynamicForm':
        navigate(
          path({
            name: 'user_module_dynamicForm_home',
            params: {
              moduleBridgeHex: userModule?.hex,
            },
          })
        );
        break;
      default:
        break;
    }
  }, [userModule]);

  useEffect(() => {
    redirect();
  }, []);

  return '';
}
